<div class="td-cnt-ext">
    <div class="td-cnt" [ngClass]="{'td-cnt-mobile' : isMobile}">
        <div class="td-cnt-title">
            <i class="fas fa-hand-holding-usd dialog-icon"></i>
            <span class="te-title">{{'costingTool.priceOptions' | translate}}</span>
        </div>
        <!-- TO BE EVALUATED -->
        <div class="td-cnt-body flex-col">

            <span class="bold" style="width: 100%;">{{'commons.description' | translate}}</span>
            <span class="span-description" [innerHTML]="costsSourceDescription || '---'"></span>
            <div *ngIf="costsSourceCostingToolRecordId != null && costsSourceCostingToolVersionId != null"
                class="cnt-link">
                <i class="fas fa-caret-right ico-link"></i>
                <teiasoft-link [text]="'costingTool.linkCostingTool' | translate"
                    (onClick)="onNavigateToCostingTool()"></teiasoft-link>
            </div>
            <div *ngIf="showItdcrHistoryLink" class="modal-link-bottom-right">
                <div class="cnt-link">
                    <i class="fas fa-caret-right ico-link"></i>
                    <teiasoft-link [text]="'enquiryBook.viewITDCR' | translate"
                        (onClick)="onNavigateToItdcrHistory()"></teiasoft-link>
                </div>
            </div>

        </div>

        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <ng-container *ngIf="!readOnly">
                <teiasoft-button (onClick)="onRecomputeClick()" class="mr-5" [type]="'tb-primary'"
                    [text]="'costingTool.recompute' | translate" [isMobile]="isMobile"></teiasoft-button>
                <teiasoft-button (onClick)="onSearchInCostingToolClick()" class="mr-5" [type]="'tb-primary'"
                    [text]="'costingTool.searchInCostingTool' | translate" [isMobile]="isMobile" [disabled]="!isRawMaterialDefined(item)"></teiasoft-button>
                <teiasoft-button (onClick)="onSelectCostFromCrClick()" class="mr-5" [type]="'tb-primary'"
                    [text]="'costingTool.selectCostFromCr' | translate" [isMobile]="isMobile" [disabled]="!isRawMaterialDefined(item)"></teiasoft-button>
                <!-- <teiasoft-button (onClick)="onSearchNearestInCostingToolClick()" class="mr-5" [type]="'tb-primary'"
                    [text]="'costingTool.searchNearestInCostingTool' | translate" [isMobile]="isMobile"
                    [disabled]="!(this.item?.costsStatus == 'ToBeEvaluated' && this.item?.costsSourceCostingToolNearestRecordId !== null)"></teiasoft-button> -->
                <teiasoft-button [type]="'tb-primary'" [text]="'costingTool.openITR' | translate" [isMobile]="isMobile"
                    [disabled]="false" [noWidth]="true" [fullWidth]="true" class="mr-5"
                    (onClick)="onOpenITDCRClick()"></teiasoft-button>
            </ng-container>
            <teiasoft-button (onClick)="onCancelClick()" class="mr-5" [type]="'tb-cancel'"
                [text]="'commons.cancel' | translate" [isMobile]="isMobile"></teiasoft-button>
        </div>
    </div>
</div>
<app-modal-price-options-cr *ngIf="showSelectCostFromCrModal" [item]="item" [isMobile]="isMobile" [theme]="theme"
    [initialFullCost]="crFullCostValue" [initialAlloySurchargeValue]="crAlloySurchargeValue"
    (onCancel)="onCancelSelectCostFromCr()" (onSave)="onSaveCostFromCr($event)">
</app-modal-price-options-cr>
<app-modal-view-itdcr *ngIf="showItdcrViewerModal" [itdcrNo]="selectedItdcrNo" [showHistory]="true"
    (onClose)="onCloseItdcrViewer()"></app-modal-view-itdcr>
